import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CaptchaComponent } from '@freelancer/captcha';
import {
  DatastoreCountriesModule,
  DatastoreCountryRequiresWhatsappModule,
  DatastoreSecurityPhoneRequestsModule,
  DatastoreUserPhoneVerificationBackoffModule,
  DatastoreUsersSelfModule,
} from '@freelancer/datastore/collections';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { PhoneVerificationModule } from 'app/verification/phone-verification/phone-verification.module';
import { ConfirmSecurityPhoneComponent } from './confirm-security-phone/confirm-security-phone.component';
import { PendingSecurityPhoneComponent } from './pending-security-phone/pending-security-phone.component';
import { RequestPhoneChangeComponent } from './request-phone-change/request-phone-change.component';
import { SecurityPhoneInputComponent } from './security-phone-input/security-phone-input.component';
import { SetupSecurityPhoneComponent } from './setup-security-phone/setup-security-phone.component';
import { UserSettingsProfileSetupSecurityPhoneModalComponent } from './user-settings-profile-setup-security-phone-modal.component';

@NgModule({
  imports: [
    CommonModule,
    DatastoreCountriesModule,
    DatastoreCountryRequiresWhatsappModule,
    DatastoreSecurityPhoneRequestsModule,
    DatastoreUserPhoneVerificationBackoffModule,
    DatastoreUsersSelfModule,
    PhoneVerificationModule,
    CaptchaComponent,
    TrackingModule,
    UiModule,
  ],
  declarations: [
    ConfirmSecurityPhoneComponent,
    PendingSecurityPhoneComponent,
    RequestPhoneChangeComponent,
    SecurityPhoneInputComponent,
    SetupSecurityPhoneComponent,
    UserSettingsProfileSetupSecurityPhoneModalComponent,
  ],
})
export class UserSettingsProfileSetupSecurityPhoneModalModule {}
